import { Image, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import type { WhoUsesCardType } from 'src/app/pages/about/main/shared/types';

export function WhoUsesCard({ icon, title, description }: WhoUsesCardType) {
	return (
		<div className="flex gap-4 py-4 md:px-4">
			<Image src={icon} alt="" className="h-14 w-14 flex-shrink-0" />
			<div>
				<Text as="h4" variant="heading" size="x-small">
					<Translate value={title} />
				</Text>
				<Text as="p" className="mt-2">
					<Translate value={description} />
				</Text>
			</div>
		</div>
	);
}
